export default "__VITE_ASSET__B$YD9bRE__"